module.exports = __webpack_public_path__ + "static/media/BD.32e1ddfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BD.svg
// module id = 2108
// module chunks = 7